<script>
	import { onMount } from 'svelte';
	import PackageJson from "../package.json";
	import Promise from 'bluebird';
	import JsZip from 'jszip';
	import FileSaver from 'file-saver';

	const cdnWebsite = "https://cdn.cake.schwarz/"
	let packages = null;
	let identifierList = [];
	let displayGroups = [];
	let insideVPN = false;
	let packageLoading = false;
	let everythingLoaded = false;

	function toggleVisibility (identifier) {
		return () => {
			const idx = identifierList.indexOf (identifier);
			if (idx >= 0) {
				identifierList.splice (idx, 1);
				identifierList = [...identifierList];
			} else {
				identifierList.push (identifier);
				identifierList = [...identifierList];
			}
		};
	}

	async function getPackages () {
		const res = await fetch('packages.json', {
			method: 'GET',
		});
		const json = await res.json ();
		return json;
	}

	function downloadFileList (filesList, concurrentDownloads = 5) {
		const download = url => {
			return fetch(url).then(resp => resp.blob());
		};

		return Promise.map(
			filesList, 
			async (url) => {
				return await download (url);
			},
			{
				concurrency: concurrentDownloads
			}
		);
	}

	async function downloadPackage (packageDefinition, version) {
		if (packageLoading) {
			return;
		}
		packageLoading = true;

		const packageDef = packages [packageDefinition];
		let filesList = packageDef.files [version];
		if (!Array.isArray (filesList)) {
			filesList = [filesList];
		}

		// download all the files in this list
		const downloads = await downloadFileList (filesList.map (f => `${cdnWebsite}${f}`));

		// export files as zip
		const zip = JsZip ();
		for (const [idx, download] of downloads.entries ()) {
			zip.file (filesList [idx], download);
		}
		zip.generateAsync ({
			type: "blob"
		}).then (zipFile => {
			packageLoading = false;
			return FileSaver.saveAs (zipFile, `${(packageDefinition + "_" + version).replace (/[^a-zA-Z0-9\-\.]/igm, "_")}.zip`);
		});


	}

	async function prepareDisplayGroups (packages) {
		const OthersGroupName = "Others";
		let displayGroups = {};
		displayGroups [OthersGroupName] = [];
		for (const packageKey in packages) {
			if (packages [packageKey].projectConfiguration.displayGroup !== null) {
				if (!Object.keys (displayGroups).includes (packages [packageKey].projectConfiguration.displayGroup)) {
					displayGroups [packages [packageKey].projectConfiguration.displayGroup] = [];
				}
				displayGroups [packages [packageKey].projectConfiguration.displayGroup].push (packageKey);
			} else {
				displayGroups [OthersGroupName].push (packageKey);
			}
		}
		displayGroups._sort = Object.keys (displayGroups).filter (k => k !== OthersGroupName).sort ();
		displayGroups._sort.push (OthersGroupName);
		return displayGroups;
	}

	async function isInsideVPN () {
		try {
			const response = await window.fetch ("/internal/cake.placeholder");
			const responseText = await response.text ();
			if (response.status == 200 && responseText.includes ("cake.placeholder")) {
				return true;
			}
			return false;
		} 
		catch (e) {
			return false;
		}	
	}

	onMount(async () => {
		packages = await getPackages ();
		insideVPN = await isInsideVPN ();
		displayGroups = await prepareDisplayGroups (packages);
		everythingLoaded = true;
	});

</script>

<main>
	<h1>CDN.CAKE</h1>
	<span class="cdn-version">{ PackageJson.version }</span>
	<h2><a href="https://cdn.cake.schwarz">https://cdn.cake.schwarz</a></h2>

	{#if everythingLoaded }
		<section>
			<h3>Available packages:</h3>

			<ul class="group-list">
				{#each displayGroups._sort as displayGroup }
					<li class="group-list-item">
						<h4 class="group-title">
							{ displayGroup } ({displayGroups [displayGroup].length})
							<button class="button-link group-title-link" on:click={toggleVisibility ("group-" + displayGroup)}>{ identifierList.includes ("group-" + displayGroup) ? "hide" : "show" } packages</button>
						</h4>

						{#if identifierList.includes ("group-" + displayGroup)}
							<ul class="package-list">
								{#each displayGroups [displayGroup] as packageDefinition } 
									<li class="package-list-item">
										<span class="package-version-title">
											{ packages [packageDefinition].projectConfiguration.name || packageDefinition + (packages [packageDefinition].isFlattenedFile ? packages [packageDefinition].extension : "") }
										</span>
										<span class="package-versions">
											versions: { packages [packageDefinition].versions.length }
										</span>
										{#if identifierList.includes (packageDefinition)}
											<ul class="package-versions-list">
												{#each ["latest", ...packages [packageDefinition].versions] as version }
													<li class="package-versions-list-item">
														<span class="package-versions-list-title">
															@{ version }
														</span>
														<span class="package-versions-show-details">
															{#if !packages [packageDefinition].projectConfiguration.visibility || insideVPN }
																<button class="button-link package-versions-show-details-link" disabled={packageLoading} on:click={downloadPackage (packageDefinition, version)}>
																	{ !packageLoading ? `download files` : `loading…` }
																</button>
															{/if}
															<button class="button-link package-versions-show-details-link" on:click={toggleVisibility (packageDefinition + version)}>
																{identifierList.includes (packageDefinition + version) ? "hide" : "show"} files
															</button>
														</span>
														{#if identifierList.includes (packageDefinition + version)}
															<ul class="package-versions-files-list">
																{#each (packages [packageDefinition].isFlattenedFile ? [packages [packageDefinition].files [version]] : packages [packageDefinition].files [version]) as file}
																	<li>
																		<a class="package-versions-files-link" target="_blank" href="{cdnWebsite}{file}">
																			{cdnWebsite}{file}
																		</a>
																	</li>
																{/each}
															</ul>
														{/if}
													</li>
												{/each}
											</ul>
										{/if}
										<button class="button-link package-list-item-link" on:click={toggleVisibility (packageDefinition)}>{ identifierList.includes (packageDefinition) ? "hide" : "show" } versions</button>
									</li>
								{/each}
							</ul>
						{/if}
					</li>
				{/each}
			</ul>
		</section>
	{/if}
</main>

<style>
	:root {
		background-color: #565656;
		font-family: Roboto,-apple-system,BlinkMacSystemFont,"Segoe UI","Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
	}
	main {
		text-align: center;
		color: #FFF;
		padding: 1em;
		margin: 0 auto;
	}
	h1 {
		font-size: 4.25rem;
		font-weight: 700;
		line-height: 1.2;
		text-transform: uppercase;
		margin-bottom: 0;
	}

	.cdn-version {
		display: inline-block;
		font-size: .8rem;
		margin-top: -2rem;
		margin-bottom: .5rem;
	}

	h2,
	h2 a,
	h2 a:hover,
	h2 a:visited,
	h2 a:active {
		color: #FFF;
		font-size: 1.25rem;
		font-weight: 400;
		line-height: 1.2;
		margin-top: 0;
	}

	section {
		text-align: left;
	}

	.button-link {
		border: 0;
		background: none;
		text-align: right;
		cursor: pointer;
	}
	.button-link:disabled {
		opacity: .6;
		cursor: not-allowed;
	}

	.group-list {
		list-style: none;
		padding: 0;
		margin: 0;
		margin-left: 1rem;
	}

	/* .group-list-item {} */

	/* .group-title {} */

	.group-title-link {
		color: #FFF;
		font-style: italic;
		text-decoration: underline;
	}

	.package-list {
		list-style: none;
		padding: 0;
		margin: 0;
	}

	.package-list-item {
		background-color: #FFF;
    	color: #3a3a3a;
		padding: 1rem;
		margin-bottom: 1rem;
		display: flex;
		flex-wrap: wrap;
	}

	.package-version-title {
		flex: 1 1 auto;
		font-weight: bold;
	}
	.package-versions {
		flex: 0 1 auto;
	}
	.package-version-title,
	.package-versions {
		border-bottom: 1px solid #3a3a3a;
		padding-bottom: .5rem;
	}
	.package-list-item-link {
		flex: 1 1 100%;
		margin-top: 1rem;
	}


	.package-versions-list {
		flex: 1 0 calc(100% - 2rem);
		list-style: none;
		padding: 0;
		margin: 0;
		margin-top: 1rem;
		margin-left: 1rem;
		margin-right: 1rem;
	}
	.package-versions-list-title {
		flex: 1 1 auto;
	}
	.package-versions-show-details {
		flex: 0 1 auto;
	}
	.package-versions-list-title,
	.package-versions-show-details {
		padding: 1rem;
	}
	.package-versions-show-details-link,
	.package-versions-show-details-link:hover,
	.package-versions-show-details-link:active,
	.package-versions-show-details-link:visited {
		text-decoration: underline;
		color: #3a3a3a;
		font-style: italic;
		font-size: .8em;
	}

	.package-versions-list-item {
		display: flex;
		flex-wrap: wrap;
	}
	.package-versions-files-list {
		flex: 1 0 100%;
		list-style: none;
		width: 100%;
	}
	
	.package-list-item-link,
	.package-list-item-link:hover,
	.package-list-item-link:active,
	.package-list-item-link:visited,
	.package-versions-files-link,
	.package-versions-files-link:hover,
	.package-versions-files-link:active,
	.package-versions-files-link:visited {
		text-decoration: underline;
		color: #3a3a3a;
		font-style: italic;
		font-size: .8em;
		cursor: pointer;
	}

</style>
